<div class="dashboard-container">
  <div>
    <app-game-list></app-game-list>
  </div>
  <div>
    <app-host-stats></app-host-stats>
  </div>
</div>
